var _circle, _circle2, _circle3, _circle4, _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonationSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 130,
    fill: "#FFE1BE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 115,
    fill: "#FFC47D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 100,
    fill: "#FFB051"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 85,
    fill: "#FF9D28"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.5,
    cy: 130,
    rx: 68.5,
    ry: 70,
    fill: "#FF8A00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.2322 124.782C106.093 137.279 114.782 148.618 122.753 162.584C135.746 142.975 148.993 123.324 169.371 102.792L164.914 100.014C148.116 114.063 134.73 127.675 122.5 144.309C116.331 137.106 106.202 126.739 99.9089 121.277L97.2322 124.782Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.1709,
    height: 74.9951,
    fill: "white",
    transform: "translate(99.2568 88) rotate(7.09052)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationSucess);
export default __webpack_public_path__ + "static/media/Donation_sucess.827bc0397a234a881f81202927e6a71a.svg";
export { ForwardRef as ReactComponent };